// Terms and Conditions page - uses tenant branding when on tenant subdomain
import React from "react"
import { Link } from "react-router-dom"
import { useBranding } from "@/contexts/branding-context"
import { getCurrentTenantId } from "@/lib/tenant"

export default function TermsPage() {
  const tenantId = getCurrentTenantId()
  const { logoUrl, businessName, termsAndConditionsName } = useBranding()

  const displayName = termsAndConditionsName
  const logoSrc = tenantId && logoUrl ? logoUrl : "/logo-with-text.png"

  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <Link to="/" className="flex justify-center mb-8">
        <img src={logoSrc} alt={`${businessName} Logo`} className="h-16 w-auto" />
      </Link>
      <h1 className="text-3xl font-bold mb-6">{displayName}</h1>
      <p className="mb-4">
        By using {businessName} services, you agree to these terms and conditions. Please read them carefully.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Membership Terms</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Membership fees are non-refundable unless otherwise stated.</li>
        <li>You must comply with gym rules and regulations at all times.</li>
        <li>We reserve the right to suspend or terminate membership for violations.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p className="mb-4">
        For questions about these terms, please contact our staff at the gym or via the contact information provided in your membership agreement.
      </p>
      <p className="mt-8 text-sm text-muted-foreground">Last updated: June 2025.</p>
    </main>
  )
}
